export default {
    data() {
        return {
            idStyle: ''
        }
    },
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        html() {
            return this.data.html
        },
    },
    mounted() {
        this.idStyle = 'style-cert-' + Date.now();
        const style = $(`<style id="${this.idStyle}">${this.data.css}</style>`);
        $('head').append(style);
    },

    beforeDestroy() {
        $(`#${this.idStyle}`).remove();
    },
    template: `<div v-html="html"></div>`
};
